import React from "react";

import { noop } from "neetocist";
import PropTypes from "prop-types";

import Activity from "./Activity";
import Comment from "./Comment";
import { ENGAGEMENT_TYPES } from "./constants";
import "./engagements.scss";
import { defaultMatchType } from "./utils";

const Engagements = ({
  data,
  isActivitiesEnabled = false,
  matchType = defaultMatchType,
  renderComment,
  renderActivity,
}) => {
  const rendererHashmap = {
    [ENGAGEMENT_TYPES.COMMENT]: renderComment,
    [ENGAGEMENT_TYPES.ACTIVITY]: isActivitiesEnabled ? renderActivity : noop,
  };

  return (
    <>
      {data.map((engagement, index) => {
        const type = matchType(engagement);
        const renderer = rendererHashmap[type];
        if (!renderer) return null;

        return (
          <React.Fragment key={engagement.id}>
            {renderer(engagement, index)}
          </React.Fragment>
        );
      })}
    </>
  );
};

Engagements.displayName = "Engagements";
Engagements.Comment = Comment;
Engagements.Activity = Activity;
Engagements.TYPES = ENGAGEMENT_TYPES;

Engagements.propTypes = {
  /**  An array of engagement items */
  data: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string.isRequired }))
    .isRequired,

  /** Boolean, determines whether activities are rendered. Defaults to false  */
  isActivitiesEnabled: PropTypes.bool,

  /** Optional function to match the item type. Receives item as argument and should return one of Engagements.TYPES.*/
  matchType: PropTypes.func,

  /** A function to render individual comment item. Receives comment and index as arguments  */
  renderComment: PropTypes.func.isRequired,

  /** A function to render individual activity item. Receives comment and index as arguments  */
  renderActivity: PropTypes.func.isRequired,
};

export default Engagements;
